<template>
  <div class="home">
    <Item
      v-for="(item, index) in items"
      :key="index"
      :IsBlackAndWhite="item.blackAndWhite"
      :Position="position"
      :Next="next"
      :Before="before"
      :Index="index"
      :Last="last"
      :Source="item.images"
    ></Item>
    <div class="email" style="opacity: 0;">
      <!-- <a href="mailto:info@olokun.com"
        ><span>info@olokun.com</span></a
      > -->
    </div>
  </div>
</template>
<script>
import Item from "./Item";
export default {
  name: "home",
  data() {
    return {
      position: 0,
      next: 1,
      before: 0,
      last: false,
      elements: [],
      items: [
        {
          color: "black",
          id: 7,
          blackAndWhite: true,
          images: "",
        },
      ],
    };
  },
  beforeMount() {
    console.log("Mount Loading...");
  },
  mounted() {
    //this.start();
    console.log("Remove Loading...");
  },
  async created() {
    this.getDate();
  },
  methods: {
    init: function() {
      let elements = document.getElementsByClassName("content");
      this.elements = elements;
      this.recursive(0);
    },
    getDate: function() {
      console.log('getdata');
      fetch("http://portal.olokun.com/api/images/getall.php")
      .then((r) => {
        if (r.status === 200) return r.json();
      })
      .then((response) => {
        if (response) {
          response.map((item) => {
            this.items.push({
              color: "white",
              id: item.id,
              blackAndWhite: false,
              images: "http://portal.olokun.com/images/" + item.images,
            });
          });
          this.init();
        }
      })
      .catch(() => {
        alert("Error processing request.");
      })
    },
    recursive: function(index) {
      console.log("Start Recursive", index);
      var element = this.elements[index];
      var beforeElement = index == 0 ? undefined : this.elements[index - 1];
      if (index === 1) {
        beforeElement = beforeElement.getElementsByClassName("bg")[0];
      }
      // stop slideshow
      //if(index === 2) return;
      if (index >= this.elements.length) {
        console.log("End Start Agaibn", index);
        if (beforeElement !== undefined) {
          if (beforeElement.classList) {
            beforeElement.classList.remove("active");
            beforeElement.classList.remove("animaterighttoleft");
            beforeElement.classList.remove("animate");
            beforeElement.classList.remove("animatelefttoexit");
          }
        }
        index = 0;
        this.recursive(index);
        return;
      }
      if (index === 0) {
        document.getElementsByClassName("email")[0].style.opacity = "0";
        setTimeout(() => {
          let firstElement = element.getElementsByClassName("bg")[0];
          firstElement.classList.add("animate");
          let endAnimationFirst = () => {
            console.log("End Animation", index);
            index = index + 1;
            firstElement.removeEventListener("animationend", endAnimationFirst);
            setTimeout(() => this.recursive(index), 1000);
          };
          firstElement.addEventListener("animationend", endAnimationFirst);
        }, 2000);
      } else {
        setTimeout(
          () =>
            (document.getElementsByClassName("email")[0].style.opacity = "1"),
          2000
        );
        let firstElement = element;
        firstElement.classList.add("active");
        let endAnimation = () => {
          if (beforeElement) {
            beforeElement.classList.remove("active");
            beforeElement.classList.remove("animaterighttoleft");
            beforeElement.classList.remove("animate");
            beforeElement.classList.remove("animatelefttoexit");
          }
          firstElement.removeEventListener("animationend", endAnimation);
          console.log("End Animation", index);
          //  if (index > 0 && index % 4 == 0) {
          //   console.log("Black And White");
          //   let firstElement = element.getElementsByClassName("bg")[0];
          //   firstElement.classList.add("animate");
          //   let endAnimationFirst = () => {
          //     console.log("End Animation", index);
          //     index = index + 1;
          //     firstElement.removeEventListener(
          //       "animationend",
          //       endAnimationFirst
          //     );
          //     setTimeout(() => this.recursive(index), 1000);
          //   };
          //   firstElement.addEventListener("animationend", endAnimationFirst);
          //   return;
          // }
          if (index + 1 >= this.elements.length) {
            console.log("End Element - Go to Exit");
            let endAnimationLast = () => {
              firstElement.classList.remove("active");
              firstElement.removeEventListener(
                "animationend",
                endAnimationLast
              );
              index = index + 1;
              setTimeout(() => this.recursive(index), 1000);
            };
            firstElement.addEventListener("animationend", endAnimationLast);
            setTimeout(() => {
              setTimeout(
                () =>
                  (document.getElementsByClassName("email")[0].style.opacity =
                    "0"),
                100
              );
              firstElement.classList.remove("animaterighttoleft");
              firstElement.classList.add("animatelefttoexit");
            }, 1000);
          } else {
            index = index + 1;
            setTimeout(() => this.recursive(index), 1000);
          }
        };
        firstElement.addEventListener("animationend", endAnimation);
        firstElement.classList.add("animaterighttoleft");
      }
    },
  },
  components: {
    Item,
  },
};
</script>
<style src="@/assets/styles/home.css"></style>
